// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"bbd10942","167":"77636721","235":"a0ef3224","382":"b440125e","650":"087868ac","815":"81b101cc","832":"52f3872d"}[chunkId] + ".chunk.js";
};